import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ClipboardService } from "app/shared/clipboard/clipboard.service";

@Component({
  selector: "app-clipboard-row",
  templateUrl: "./clipboard-row.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClipboardRowComponent {
  private clipboardService = inject(ClipboardService);

  public readonly textToBeCopied = input(undefined);

  public copyToClipboard(event: MouseEvent): void {
    this.clipboardService.copyToClipboard(this.textToBeCopied());
    event.stopPropagation();
  }
}
